import React, { useCallback, useState } from 'react';
import CommonFormFields from '../../../../Forms/CommonFormFields';
import Button from '@components/common/Button';
import './HFRVerifyComponent.css';
import endpoints from '@config/endpoints';
import Auth from "../../../../../utils/auth";
import axios from '../../../../../utils/axiosExt';
import { errorLogger } from '@utils/applicationLogUtils';
import { decodeWithKeyAndShift } from '@utils/base64Utils';

type propsType = {
    formData: {
      [key: string]: any;
    };
    actualFormData:any;
    formState:any;
    handleFormChange:(value: any, key: string, id: any, option: any, code: any)=>void;
    facilityLocationId?:any,
    facilityLocationType?:any,
    healthFacilityNames?:any
  };

  enum LocationType {
    Village = 'village',
    Ward = 'ward',
    GP = 'gp'
  }
  
  enum UserDesignation{
    anm='ANM',
  }
  interface Data {
    hfrId: string;
    locationId: string;
    locationType: LocationType
  }

  

const HFRVerifyComponent = ({formData,actualFormData,formState,handleFormChange, facilityLocationId,facilityLocationType,healthFacilityNames}: propsType) => {
  const userDetails = localStorage.getItem('userDetails');
  const loggedInUserDetails=JSON.parse(decodeWithKeyAndShift(userDetails));
  const isLoggedInUserANM = () => {
    const designationName = loggedInUserDetails?.user_designation_name;
    return designationName === UserDesignation.anm;
  }
  const healthFacilityData =(hfrId:any) => {     
    const healthFacility = healthFacilityNames.facilityOptions.filter((facility:any) => facility.hfr_id === hfrId);
    if (healthFacility?.length > 0) {
      const facilityNameData = {
       facility_name:healthFacility[0]?.value,
       facilit_id : healthFacility[0]?.id,
       hfr_id : healthFacility[0]?.hfr_id,
       facility_type_id : healthFacility[0]?.fac_type_id,
       facility_type : healthFacility[0]?.facilitytypename       
      }
      handleFormChange(healthFacility[0]?.value, 'health_facility_name', null,actualFormData?.health_facility_name['#options'], null);
      handleFormChange(healthFacility[0]?.facilitytypename, 'health_facility_type', null, actualFormData?.health_facility_type['#options'], null);
      handleFormChange(healthFacility[0]?.hfr_id, 'hfr_id', healthFacility[0]?.id, facilityNameData, null);
    } else {
      handleFormChange('', 'health_facility_name', null, actualFormData?.health_facility_name['#options'], null);
      handleFormChange('', 'health_facility_type', null, actualFormData?.health_facility_type['#options'], null);
    }
  }
    const handleHFRVerifyButtonClick = useCallback(async () => {
      if (isLoggedInUserANM()) {
        formState.hfr_id.value && healthFacilityData(formState.hfr_id.value);
        return;
      }      
      const data : Data = {
        hfrId : formState.hfr_id.value,
        locationId:facilityLocationId,
        locationType:facilityLocationType,
      }
      if(data.hfrId && data.locationId && data.locationType)
      {
        try {
          const response = await axios.post(`${endpoints.getFacilityByHFRId}`, data, Auth.loggedIn());
          const facilityData = response?.data?.data;
          if (response.status === 200 && facilityData.length > 0) {
            handleFormChange(facilityData[0]?.facility_name, 'health_facility_name', null, null, null);
            handleFormChange(facilityData[0]?.facility_type, 'health_facility_type', null, facilityData[0]?.facility_type_id, null);
            handleFormChange(facilityData[0]?.hfr_id, 'hfr_id', facilityData[0].id, facilityData[0], null);
          } else {
            handleFormChange('', 'health_facility_name', null, null, null);
            handleFormChange('', 'health_facility_type', null, null, null);
          }
        } catch (error:any) {
          if (error.response && error.response.status === 404) {
            handleFormChange('', 'health_facility_name', null, null, null);
            handleFormChange('', 'health_facility_type', null, null, null);
          } else {
            errorLogger(`Error fetching facility data: ${error.message}`)
          }
        }
      }else{
        errorLogger(`Error fetching facility data. HFR ID, Location Id or Location type missing.`)
      }
    }, [formState.hfr_id.value, handleFormChange]);

  return (
    <div className="hfr_verify_container">
        <CommonFormFields
            formData={formData}
            formState={formState}
            handleFormChange={handleFormChange}
        />
      <div className="hfr_button_verify_user_creation">
        <Button
            onClick={handleHFRVerifyButtonClick}
            disabled={formData?.hfrId?.['#isDisabled'] || false}
            buttonName={'Search'}
            colorType={'primary'}
            id={'hfr-verify-btn'}
        />
      </div>
    </div>
  );
};
export default HFRVerifyComponent;
